var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"c-file-uploader"},[_c('input',{ref:"input",staticStyle:{"display":"none"},attrs:{"type":"file"},on:{"change":_vm.onChange}}),_vm._v(" "),_vm._t("default",null,{"choose":_vm.choose,"uploading":_vm.uploading})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }